import React from "react"

import { Dropdown, DropdownItem, Link } from "@bounce/web-components"

export type DropdownSelectorProps = {
  value?: string
  items: {
    id: string
    label: string
    href: string
  }[]
}

export const DropdownSelector = ({ value, items }: DropdownSelectorProps) => {
  if (items.length === 0) return null

  const currentItem = items.find(item => item.id === value) ?? items[0]

  return (
    <Dropdown id="product-selector" label={currentItem?.label} items={items}>
      {items.length > 1
        ? items.map(({ id, href, label }) => (
            <DropdownItem as={Link} key={id} href={href}>
              {label}
            </DropdownItem>
          ))
        : []}
    </Dropdown>
  )
}
